import React, { Component } from "react";
import { Col ,Row} from "reactstrap";
import { NavLink } from "react-router-dom";
import Rating from '../rating'



class AnnonceCard extends Component {
  state = {};
  render() {
    const { rating, imgPath, linkPath, hotelName, map ,idcard,type} = this.props;
    return (
      <Col sm="3" xs="12" className="text-center mb-3 mb-sm-0 responsive">
        <div
          className=" card-content-item  text-center"
          onMouseOver={() => {
            document.getElementById(idcard).classList.add("green");
          }}
          onMouseLeave={() => {
            document.getElementById(idcard).classList.remove("green");
          }}
        >
          <NavLink to={linkPath}>
            <div className="red" >
              <img className="img-fluid annonce" src={imgPath}  alt="Hotel"/>
              <div className="footercard d-flex flex-column justify-content-center" id={idcard}>
                  {/* <Col className="col-7" style={{wordWrap:"break-word"}}>
                    <h5 className="type-hebrg">Hotel</h5>
                    <h5 className="type-hebrg" style={{height:"40px",wordWrap:"break-word"}}>{hotelName}</h5>
                  </Col> */}
                  <div className="d-flex">
                  <h5 className="type-hebrg hebergCardType">{type || "Hotel"}</h5>
                  <div className="ml-auto mr-1">
                  <img
                        src="/imgs/announces/pin.svg"
                        alt=""
                        id="pin-position"
                      />
                      <span className="place-position">{map}</span>
                  </div>
                  </div>

                  <div className="d-flex align-items-center">
                  <h5 className="type-hebrg hebergCardName text-nowrap" style={{height:"30px",wordWrap:"break-word"}}>{hotelName}</h5>
                   <div className="ml-auto  mr-1"><Rating starts={rating} color={"white"} /></div>

                  </div>
              </div>
            </div>
          </NavLink>
        </div>
      </Col>
    );
  }
}

export default AnnonceCard;



